import axiosInstance from "../../../axios";

export const getNotifications = async (param) => {
  console.log("notification Obj ", param);
  try {
   
    const {data} = await axiosInstance.get(`/notifications/allNotifications?pageNo=${param?.page}&pageLength=${param?.limit}`);
    console.log(
      "Response data inside the get notificatioon service : -> ",data
    );
    return data?.payload;
  } catch (error) {
    console.error("Error in get notification service:", error);
    throw error;
  }
};
